import React from 'react';
import PropTypes from 'prop-types';
import { useTeamContext } from '@/hooks/useTeamContext';

const RoleGuard = ({ allowedRoles = [], requiredPermissions = [], requireAll = false, hideWhenNoAccess = true, fallback = null, children }) => {
  const { effectiveRole, permissions } = useTeamContext();

  const hasRoleAccess = () => {
    if (!allowedRoles || allowedRoles.length === 0) return true;
    const rolesArray = Array.isArray(allowedRoles) ? allowedRoles : [allowedRoles];
    return rolesArray.includes(effectiveRole);
  };

  const hasPermissionAccess = () => {
    if (!requiredPermissions || requiredPermissions.length === 0) return true;
    const permissionsArray = Array.isArray(requiredPermissions) ? requiredPermissions : [requiredPermissions];
    const userPermissions = permissions || [];
    return requireAll ? permissionsArray.every((perm) => userPermissions.includes(perm)) : permissionsArray.some((perm) => userPermissions.includes(perm));
  };

  const hasAccess = hasRoleAccess() && hasPermissionAccess();

  if (!hasAccess) {
    return hideWhenNoAccess ? null : fallback;
  }

  return <>{children}</>;
};

RoleGuard.propTypes = {
  allowedRoles: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  requiredPermissions: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  requireAll: PropTypes.bool,
  hideWhenNoAccess: PropTypes.bool,
  fallback: PropTypes.node,
  children: PropTypes.node.isRequired,
};

export default RoleGuard;
